<template>
  <div class="pharma">
    <el-drawer
      :withHeader="false"
      size="900px"
      :visible.sync="drawer"
      direction="ltr">
      <iframe :src="url" frameborder="0" class="read_pdf"></iframe>
    </el-drawer>
    <el-row>
      <el-col :span="8">
        <el-link :underline="false" href="https://ydz.chp.org.cn/#/main" target="_blank" style="margin: 10px 0 -8px 17px;font-size: 13.5px;">
          <i class="el-icon-caret-right" style="padding-right: 7px;color: #C0C4CC;font-size: 11px;">
        </i>中国药典</el-link>
        <div class="tree">
          <el-tree
            :props="props"
            :load="loadNode"
            @node-click="handleNodeClick"
            highlight-current
            accordion
            lazy>
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span class="explain" v-if="data.name.length<30">{{data.name}}</span>
              <el-tooltip v-else class="explain" effect="dark" :content="node.data.name" placement="top">
                <span>{{data.name}}</span>
              </el-tooltip>
            </span>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="content">
          <p class="explain"><b>数据库说明: </b>本数据库包含欧洲药典\美国药典\英国药典, 对<span style="color: #A7231E">VIP3及以上用户</span>开放使用!</p>
          <div class="pci_table">
            <table>
              <thead>
                <th>VIP等级</th>
                <th>VIP类型</th>
                <th>查看/下载量</th>
                <th>VIP类型</th>
                <th>查看/下载量</th>
              </thead>
              <tbody>
                <tr>
                  <td>VIP3</td>
                  <td>包月</td>
                  <td><span style="color: #A7231E">20</span>次/天</td>
                  <td>包年</td>
                  <td><span style="color: #A7231E">30</span>次/天</td>
                </tr>
                <tr>
                  <td>VIP4</td>
                  <td>包月</td>
                  <td><span style="color: #A7231E">40</span>次/天</td>
                  <td>包年</td>
                  <td><span style="color: #A7231E">60</span>次/天</td>
                </tr>
              </tbody>
            </table>
            <p class="red">注：如未查到目标文件, 请联系客服。</p>
          </div>
          <p class="searching">
            <el-col :span="12">
              <el-input size="mini" v-model="input" placeholder="请输入内容" @keyup.enter.native="search"></el-input>
            </el-col>
            <el-col :span="12" style="padding-left:15px">
              <el-button size="mini" @click="search">搜索</el-button>
              <el-button size="mini" @click="reset_search">重置</el-button>
              <el-dropdown @visible-change="visible_change" @command="command">
                <span class="el-dropdown-link">
                  今日下载/阅读历史<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="pull_down">
                  <el-dropdown-item :command="JSON.parse(y)" v-for="(y, k, i) in history_data" :key="i">({{i+1}}) {{JSON.parse(y)["name"]}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </p>
          <div class="result">检索结果: <span>{{total}}</span> 条
            <div class="result-dropdown">
              筛选:
              <el-select v-model="source" placeholder="来源" clearable size="mini" style="width: 110px;margin-right:10px" @change="change_source">
                <el-option
                  v-for="(y,k,i) in options"
                  :key="i"
                  :label="k"
                  :value="k">
                </el-option>
              </el-select>

              <el-select v-model="versions" placeholder="版本" clearable size="mini" style="width: 230px" @change="change_versions">
                <el-option
                  v-for="item in options[source]"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <el-table
            :data="tableData"
            border
            size="mini"
            class="table"
            v-loading="request_status"
            style="width: 100%">
            <el-table-column
              fixed
              type="index"
              label="序号"
              width="45">
            </el-table-column>
            <el-table-column
              prop="name"
              width="350px"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="source"
              width="70px"
              label="来源">
            </el-table-column>
            <el-table-column
              prop="versions"
              width="230px"
              label="版本">
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="o"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="read(scope.row)">查看</el-button>
                <el-button type="text" size="mini" @click="download(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              size='mini'
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="page_size"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
  export default {
    data() {
      return {
        props: {},
        input: "",
        now_node: null,
        tableData: [],
        total: 0,
        page_size: 15,
        page: 1,
        request_status: false,
        drawer: false,
        url: "",
        history_data: {},
        pdf_status: true,
        options: [],
        source: "",
        versions: ""
      };
    },
    created () {
      this.search_data()
    },
    methods: {
      // 页面更改
      handleSizeChange(val) {},

      handleCurrentChange(val) {
        this.page = val
        this.search_data(false)
      },

      reset_search () {
        this.input = ""
        this.now_node = null
        this.page = 1
        this.search_data()
      },

      search () {
        this.page = 1
        this.search_data()
      },

      read (row) {
        if (!this.pdf_status) { return }
        this.pdf_status = false
        axios({
            method:"get",
            url:`/api/operation/Pharmacopeia/?_id=${row._id}&t=${row.time}&d=${JSON.stringify(row)}&code=${row.code}&name=${row.name}&source=${row.source}&versions=${row.versions}`,
            headers: {"Authentication": localStorage.getItem('login_info'), "Authentication-Fp": localStorage.getItem("fp"),
              'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
            responseType: 'blob',
          }).then((response)=>{
            if (response.data.type == "text/html") {
              const reader = new FileReader();
              reader.onload = (res) => {
                this.$alert(res.target.result, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {}
                });
              }
              reader.readAsText(new Blob([response.data]), 'utf-8')
            }else{
              let blob = new Blob([response.data], { type: response.data.type })
              this.url = URL.createObjectURL(blob)
              setTimeout(()=>{
                this.drawer = true
              }, 100)
            }
            this.pdf_status = true
          }).catch(error=>{
            this.pdf_status = true
          })
      },

      download (row) {
        if (!this.pdf_status) { return }
        this.pdf_status = false
        axios({
            method:"get",
            url:`/api/operation/Pharmacopeia/?_id=${row._id}&t=${row.time}&code=${row.code}&d=${JSON.stringify(row)}&attachment=1&name=${row.name}&source=${row.source}&versions=${row.versions}`,
            headers: {"Authentication": localStorage.getItem('login_info'), "Authentication-Fp": localStorage.getItem("fp")},
            responseType: 'blob',
          }).then((response)=>{
            if (response.data.type == "text/html") {
              const reader = new FileReader();
              reader.onload = (res) => {
                this.$alert(res.target.result, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {}
                });
              }
              reader.readAsText(new Blob([response.data]), 'utf-8')
            }else{
              let url = window.URL.createObjectURL(new Blob([response.data]));
          　　let link = document.createElement('a');
          　　link.style.display = 'none';
          　　link.href = url;
              link.download= row.name+'.pdf';
          　　document.body.appendChild(link);
          　　link.click();
            }
            this.pdf_status = true
          }).catch(error=>{
            this.pdf_status = true
          })
      },

      change_source() {
        this.versions = ""
        this.handleCurrentChange(1)
      },

      change_versions() {
        this.handleCurrentChange(1)
      },

      search_data (status=true) {
        this.request_status = true
        if (status){
          this.options = {}
          this.source = ""
          this.versions = ""
        }
        var tid = this.now_node?this.now_node.tid: ""
        this.$http.getPharmaData(tid, this.input, this.source, this.versions, this.page).then(resp => {
          if (resp.code == 200) {
            setTimeout(()=>{
              this.request_status = false
              this.tableData = resp.list_data
              this.total = resp.total
              if (status){
                resp.group_data.sort(function(a, b){return a.versions.split("_")[0] - b.versions.split("_")[0]});
                resp.group_data.forEach(element => {
                  if (Object.keys(this.options).indexOf(element.source)==-1){
                    this.options[element.source] = []
                  }
                  this.options[element.source].push(element.versions)
                });
              }
            }, 400)
          }else{
            this.$message({
              message: response.msg,
              type: 'warning',
              customClass: 'hint-message',
              center: true
            });
          }
        })
      },

      handleNodeClick(data) {
        this.now_node = data
        this.search()
      },
      command (row) {
        this.read(row)
      },

      visible_change (status) {
        if (status){
          this.$http.getPharmaHistoryData().then(resp=>{
            if(resp.code==200){
              this.history_data = resp.history_data
            }
          })
        }else{
          this.history_data = new Object()
        }
      },

      loadNode(node, resolve) {
        let param = new URLSearchParams();
        if (node.level === 0) {
          param.append("id", 0);
        }else{
          param.append("id", node.data.tid);
        }
        this.$http.postPharmaTree(param).then((resp)=>{
          if (resp.code == 200) {
            return resolve(resp.tree_data)
          }else{
            return resolve([])
          }
        })
      }
    }
  };
</script>

<style scoped>
.pharma {
  width: 1030px;
  margin: 0 auto;
}
.tree {
  padding: 10px;
}
.content {
  padding: 10px;
}
.explain {
  font-size: 14px;
  text-align: center;
}
.explain b{
  font-weight: 600;
}
.searching {
  padding: 10px 0;
  height: 30px;
}
.result {
  background-color:#eee;
  padding: 10px;
}
.result span {
  color: #A7231E;
  font-weight: 600;
}
.table >>> .el-button--mini {
  padding: 5px 2px;
}
.page {
  padding: 10px 0;
}
.read_pdf {
  width: 100%;
  height: 100%;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  margin-left: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.pull_down {
  max-height: 500px;
  width: 400px;
  overflow: auto;
}
table, td , th{
  border: 1px solid #777;
  padding: 2px 10px;
  font-size: 13px;
  text-align: center;
}
table {
  display: inline-block;
  padding: 0;
  border: none;
  margin-top: 10px;
  vertical-align: top;
}
.direction {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  vertical-align: top;
  margin-top: 10px;
  margin-right: 10px;
}
.red {
  color: #A7231E;
  padding: 5px 0;
  text-align: center;
  font-weight: 600;
}
.table >>> .el-table__row td, .table >>> .has-gutter th {
  padding: 0!important;
}
.pci_table {
  text-align: center;
  background-color: #efefef;
}
.result-dropdown {
  display: inline-block;
  position: relative;
  top: -6px;
  float: right;
}
</style>